import { util } from '../util/axiosConf';
const  pre = 'api/licenselmp';
export default {
  
  //获取验证码
  sendPhoneCode(params) {
    return util.get(`${pre}/train/user/frontend/sendPhoneCode?phone=${params.phone}`, params);
  },
  //验证验证码
  verifyPhoneCode(params){
    return util.post(`${pre}/train/user/frontend/verifyPhoneCode`,params)
  },
  //登录
  loginByPhoneCode(params){
    return util.post(`${pre}/train/user/frontend/loginByPhoneCode`,params)
  },
  //退出
  logout(params){
    return util.post(`${pre}/train/user/frontend/logout`,params)
  },
  //获取登录人基本信息
  getMyInfo(params) {
    return util.get(`${pre}/train/user/frontend/getMyInfo`, params);
  },
  //账号的证书列表查看
  getCerList(params){
    return util.post(`${pre}/train/certification/frontend/cerList`,params)
  },
  //证书预览
  preview(caNo) {
    return util.get(`${pre}/train/certification/frontend/preview?cerId=${caNo}`);
  },
  //证书下载
  download(params){
    return util.post(`${pre}/train/certification/frontend/download`,params,{responseType: "blob"})
  },
};
